.dda-team-member-card{
  padding: 24px 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.dda-team-member-card-header{
  display: flex;
}
.dda-team-member-card-header svg path{
  fill: var(--dda-on-surface-0);
}
.light-mode .dda-team-member-card-header svg path{
  fill: var(--dda-neutral-0);
}
.dda-team-member-card-image {
  display: block;
  margin: 0 auto;
  width: 93px;
  height: 93px;
  border-radius: 50%;
}



.dda-team-member-card-position {
  color: #666;
}

.dda-team-member-card-body{
  display: flex;
}
.dda-team-member-card.dda-team-member-card-blue{
  background: var(--dda-neutral-variant-92);
}

.dda-team-member-card-blue .dda-team-member-card-header i,
.dda-team-member-card-blue .card-balance-label,
.dda-team-member-card-blue .card-balance,
.dda-team-member-card-blue .dda-card-name,
.dda-team-member-card-blue .dda-card-number{
  color: var(--dda-neutral-100);
}
.dda-team-member-card-blue .dda-team-member-card-header svg path{
  fill: var(--dda-neutral-100);
}